import createReducer from './reducers';
export default createReducer;
